import type { IFuelParameters } from '../models/parameters.model';
import type { IFuelResult } from '../models/result.model';

export class FuelCalculator {
  static calculateTotalCost(params: IFuelParameters): IFuelResult {
    return {
      costInSek: this.calculatePrimaryFuelCost(params),
    };
  }

  static calculateMonthlyFuelCost(params: IFuelParameters): number {
    const drivingDistancePerMonth10Km = (params.drivingDistancePerYearKm ? params.drivingDistancePerYearKm / 12 : params.travelDaysPerMonth * params.distanceToWorkKm * 2) / 10;

    return Math.round(drivingDistancePerMonth10Km * (params.consumptionUnitsPer10Km || 0) * (params.fuelPriceSek || 0));
  }

  private static calculatePrimaryFuelCost(params: IFuelParameters): number {
    return Math.round((params.workDrivingDistancePerMonthKm / 10) * (params.consumptionUnitsPer10Km ?? 0) * (params.fuelPriceSek ?? 0));
  }
}
